import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PauseTransportService } from '../../service/pause-transport.service';
import { ResponseStatus } from '@sdbn/common';
import { ResponseMessage } from '@sdbn/common';

export interface EndTransportPauseDialogData {
  transportId: number;
  carrier: string;
  name: string;
  identifier: string;
  transportScope: any;
  successCallback: () => void;
}

@Component({
    selector: 'app-end-transport-pause-dialog',
    templateUrl: './end-transport-pause-dialog.component.html',
    styleUrls: ['./end-transport-pause-dialog.component.scss'],
    standalone: false
})
export class EndTransportPauseDialogComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<EndTransportPauseDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: EndTransportPauseDialogData,
    private pauseTransportService: PauseTransportService) { }

  responseMessages: ResponseMessage[];

  ngOnInit() { }

  confirm() {
    this.pauseTransportService.endPause({
      end: new Date(),
      transport: { id: this.data.transportId }
    }).subscribe(response => {
      if (response.status === ResponseStatus.SUCCESS) {
        this.data.successCallback();
        this.dialogRef.close();
      } else {
        this.responseMessages = response.responseMessages;
      }
    }, error => {
      console.error(error);
    });
  }

}
